// Reading-section design tokens. Based on the gallery layout but recoloured
// to match the FET app's indigo + slate palette so the reading screens feel
// native to pass-fet.com instead of being a separate beige theme.
//
// The KEY difference vs. the gallery: surfaces are slate-white (#F8FAFC /
// #FFFFFF), accent is the app indigo (#5B52F0), and ink colours are slate
// rather than warm browns. Per-part accent colours (p1–p5) are kept distinct
// so each reading part still has its own visual identity.

export const T = {
  // surface
  bg: '#F8FAFC', bgSunk: '#F1F5F9', surface: '#FFFFFF', surface2: '#F8FAFC',
  hairline: '#E2E8F0', hairlineInk: '#CBD5E1',
  // ink
  ink: '#0F172A', ink2: '#475569', ink3: '#64748B', ink4: '#94A3B8',
  // accent — app indigo
  blue: '#5B52F0', blueInk: '#4338CA', blueBg: '#EEF2FF', blueEdge: '#C7D2FE',
  // feedback
  ok: '#16A34A', okBg: '#ECFDF5', okEdge: '#BBF7D0',
  miss: '#DC2626', missBg: '#FEF2F2', missEdge: '#FECACA',
  hint: '#D97706', hintBg: '#FFFBEB', hintEdge: '#FDE68A',
  // parts (per-part accent — kept distinct so each section feels different)
  p1: '#6E77D8', p2: '#5B52F0', p3: '#A86FB3', p4: '#4E8A5E', p5: '#B55A48',
  // type
  sans: "'DM Sans', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
  ar: '"IBM Plex Sans Arabic", "Noto Kufi Arabic", "Tajawal", system-ui, sans-serif',
  mono: '"JetBrains Mono", ui-monospace, Menlo, monospace',
  serif: 'Georgia, "Times New Roman", serif',
};

export const PART_META = [
  { n: 1, title: 'Signs & Notices', color: T.p1 },
  { n: 2, title: 'Gap Fill',        color: T.p2 },
  { n: 3, title: 'Text Matching',   color: T.p3 },
  { n: 4, title: 'People ↔ Place',  color: T.p4 },
  { n: 5, title: 'Long Reading',    color: T.p5 },
];
